import { gql } from '@apollo/client';
import {
  IN_BOUND_INFORMATION_FRAGMENT,
  OUT_BOUND_INFORMATION_FRAGMENT,
} from '../fragments/shippingInformationFragment';

const RMA_TICKET_QUERY = gql`
  query RmaTicket($id: ID!) {
    RmaTicket(id: $id) {
      id
      rmaId
      senderInformation {
        ...InboundInformationFragment
      }
      recipientInformation {
        ...OutboundInformationFragment
      }
      clinicNotes
      facility {
        id
        name
        status
        programs {
          protectPlus
          renewalStock
        }
        enabledPrograms
      }
      requestedAt
      status
      notificationEmail
      clinicShipmentReminder {
        isReminder
      }
      formType
    }
  }

  ${IN_BOUND_INFORMATION_FRAGMENT}
  ${OUT_BOUND_INFORMATION_FRAGMENT}
`;

export default RMA_TICKET_QUERY;
